import type { ReactElement } from 'react';
import './LoaderVariant5.css';

export function LoaderVariant5(): ReactElement {
  return <div className="lv5" />;
}
